import React from 'react';
export const LogoBanner = () => {
  return <div className="w-full bg-white py-2 border-b border-gray-100" data-id="element-118">
      <div className="container mx-auto px-4 md:px-6 flex justify-center" data-id="element-119">
        <div className="h-14 md:h-20" data-id="element-120">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1oLCgQiMkP9ukGHrvgB6m4/Aspira_Works_Logo-01.jpg" alt="Aspira Works" className="h-full" data-id="element-121" />
        </div>
      </div>
    </div>;
};